import { useEffect } from 'react';
import { useIntl } from '@doxyme/locale';
import { getProviderName } from '../../features/realtime/realtime.selectors';
import { useAppSelector } from '../useReduxToolkit';
import { useReplaceableNotification } from '../useReplaceableNotification';

export type UsePatientCallHoldNotificationProps = {
  muted: boolean;
  toggleAudio: () => void;
};

export const usePatientCallHoldNotification = ({
  muted,
  toggleAudio,
}: UsePatientCallHoldNotificationProps) => {
  const { formatMessage } = useIntl();
  const { show, hide } = useReplaceableNotification();
  const providerName =
    useAppSelector(getProviderName) ?? formatMessage({ id: 'provider' });

  useEffect(() => {
    show('callHoldPatient', {
      titlePlaceholderValues: { providerName },
      buttonText: formatMessage({
        id: `notification.callHoldPatient.${muted ? 'unmute' : 'mute'}`,
      }),
      callback: toggleAudio,
    });

    return hide;
  }, [toggleAudio, muted, providerName]);
};
